import * as z from 'zod'
import { t } from 'i18next'

export const memberUseSchema = z.object({
  no: z.number().optional(),
  title: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:landing_title_length_error') as string,
    }),
  titleInDutch: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:landing_title_in_dutch_length_error') as string,
    }),
  content: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:max_contact_content_error') as string,
    }),

  contentInDutch: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:max_contact_content_netherlands_error') as string,
    }),

  mediaId: z.number({
    required_error: t('error:field_required') as string,
  }),
  mediaMobileId: z.number({
    required_error: t('error:field_required') as string,
  }),
})
export type IMemberUse = z.infer<typeof memberUseSchema>
